import React, { FC, PropsWithChildren } from "react";
import Footer from "components/layout/footer";

type CommonLayoutProps = PropsWithChildren<unknown>;

const CommonLayout: FC<CommonLayoutProps> = ({ children }: CommonLayoutProps) => {
  return (
    <div className="app app-layout-common">
      <div className="app-content">{children}</div>
      <Footer />
    </div>
  );
};

export default CommonLayout;
